import { useState, MouseEvent } from 'react';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Theme } from '@mui/material';
import Button, { ButtonProps } from '@mui/material/Button/Button';
import { styled } from '@mui/styles';

type ArrowDirection = 'right' | 'left';

interface CalendarButtonProps extends ButtonProps {
  selected?: boolean;
}

export const CalendarButtons = styled(
  ({ selected, onClick, ...props }: CalendarButtonProps) => {
    const [isSelected, setIsSelected] = useState(selected);

    const handleSelected = (event: MouseEvent<HTMLButtonElement>) => {
      setIsSelected(!isSelected);
      if (onClick) {
        onClick(event);
      }
    };

    return (
      <Button variant="text" {...props} onClick={handleSelected} size="large" />
    );
  },
)(({ theme, selected }: { theme: Theme; selected?: boolean }) => ({
  fontSize: '20px',
  color: '#767D86',
  borderColor: 'rgba(118,125,134,0.7)',
  border: 'solid 2px',
  padding: '12px 22px',
  backgroundColor: selected ? 'rgba(118,125,134,0.20)' : 'transparent',
  borderRadius: 0,
  '&:first-child': {
    borderTopLeftRadius: theme.spacing(1),
    borderBottomLeftRadius: theme.spacing(1),
    borderRight: 'none',
  },

  '&:not(:first-child):not(:last-child)': {
    borderRadius: 0,
    borderRight: 0,
  },
  '&:last-child': {
    borderTopRightRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1),
  },
  '&:only-child': {
    borderRadius: theme.spacing(1),
    borderRight: 'solid 2px',
  },
}));

export const calendarButtonStyle = {
  fontSize: '36px',
  margin: 0,
  padding: 0,
  paddingTop: '4px',
  paddingBottom: '4px',
  color: '#767D86',
  '& .MuiButton-startIcon': {
    margin: 0,
  },
  '& .MuiButton-startIcon > *:nth-of-type(1)': {
    fontSize: 'inherit',
  },
};

export const CalendarArrowButton = styled(
  ({ direction, ...props }: ButtonProps & { direction: ArrowDirection }) => (
    <Button
      variant="text"
      {...props}
      startIcon={
        direction === 'left' ? <ChevronLeftIcon /> : <ChevronRightIcon />
      }
    />
  ),
)(() => ({
  ...calendarButtonStyle,
}));
